import useAuth from 'client/utils/auth/useAuth';
import { useIntl } from 'react-intl';
import Page from 'client/components/aria/Page/Page';
import SignedInHomePage from './SignedInHomePage';
import SignedOutHomePage from './SignedOutHomePage';
import HomePageAlert from './HomePageAlert';
import FeedbackPrompt from 'client/components/Feedback/FeedbackPrompt/FeedbackPrompt';
import PropTypes from 'prop-types';
import styles from './HomePage.module.scss';
import { useLocaleAutoSwitch } from 'i18n/localeUtils';
import { useLoaderData } from 'react-router';

const HomePage = ({ showFeedback = false }) => {
    const intl = useIntl();
    useLocaleAutoSwitch();
    const { isAuthenticated } = useAuth();
    const { homePageAbout, workspaceNotice, acceptableUsage } = useLoaderData() || {};

    const hasWorkspaceNotice = isAuthenticated && workspaceNotice?.markdown != null && workspaceNotice?.markdown.length > 0;

    return (
        <Page title={intl.formatMessage({ id: 'homePage.title' })} data-testid="homePage" className={styles.feedback}>
            <div className="govuk-grid-row">
                <div className="govuk-grid-column-full">
                    {hasWorkspaceNotice
                        ? <HomePageAlert data-testid="homePageBanner" content={workspaceNotice} />
                        : null}
                    <h1
                        data-testid="homePage.title"
                        className="govuk-heading-xl"
                    >
                        {intl.formatMessage({ id: 'homePage.title' })}
                    </h1>
                    {isAuthenticated
                        ? (
                            <>
                                <SignedInHomePage acceptableUsage={acceptableUsage} />
                                {showFeedback && <FeedbackPrompt />}
                            </>
                        )
                        : (
                            <SignedOutHomePage homePageAbout={homePageAbout} />
                        )}
                </div>
            </div>
        </Page>
    );
};

HomePage.propTypes = {
    showFeedback: PropTypes.bool
};

HomePage.defaultProps = {
    showFeedback: false
};

export default HomePage;
